import React from 'react';

import classNames from 'classnames';

export interface ISpinnerProps {
    className?: string;
}


const Spinner = (props: ISpinnerProps): JSX.Element => {
    const className: string = classNames(
        'spinner',
        props.className,
    );

    return (
        <div className={className}>
            <div className="spinner__sector" />
            <div className="spinner__sector" />
            <div className="spinner__sector" />
            <div className="spinner__sector" />
        </div>
    );
};

export default Spinner;
